// @core/api/endpoints/workflow/list_templates.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListTemplatesResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List pipeline templates
 * Returns available pipeline templates. Supports filtering by category, tags, and public/verified status.
 */
export async function ListTemplates(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListTemplatesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/templates`;
  const requestOptions = options;
  return client.get<ListTemplatesResponse>(requestPath, { ...requestOptions, params });
}
